import api from '@/api';
import Cookies from '@/portal-cookie';
import base64toPDF from '../../lib/base64ToPDF';
import { message } from 'antd';

let types = {
	SET_STATE: 'SET_STATE',
	SET_REORDER_NOTES: 'SET_REORDER_NOTES',
	SET_REORDER_LINES: 'SET_REORDER_LINES',
	SET_REORDER_LINE_QTY: 'SET_REORDER_LINE_QTY',
	RESET_REORDER_FORM: 'RESET_REORDER_FORM',
	RESET_CONFIRMATION_MODAL: 'RESET_CONFIRMATION_MODAL'
};



const initialState = {
	salesOrders: [],
	header: {},
	reOrderForm: {
		lines: [],
		notes: '',
	},
	isDPCustomer: null,
	cardCode: '',
	cardType: '',
	cardName: '',
	bpName: '',
	loading: false,
	loaded: false,
	submitPending: false,
	loadedVendorCode: false,
	customerProfileId_from_SAP: null,
	attachmentPreviewURL: '',
	showAttachmentModal: false,
	showReorderForm: false,
	showSOPDFDialog: false,
	pdfModalLoading: false,
	showPreviewPDFDialog: false,
	pdfModalKey: null,
	pdfFilePreview: null,
	pdfModalData: null,

	rejectionModal: false,
	selectedSO: [],
	updateSuccessModal: false,
	updatePending: false,
	confirmationSuccess: false,
	rejectionSuccess: false,
	responseMessage: '',
}


export const reducers = (state = initialState, action) => {
	switch (action.type) {
		case types.SET_STATE:
		{
			return {...state, ...action.data };
		}
		case types.SET_REORDER_NOTES:
		{
			return {
				...state,
				reOrderForm: {
					...state.reOrderForm,
					lines: [...state.reOrderForm.lines],
					notes: action.data.notes,
				}
			}
		}
		case types.SET_REORDER_LINES:
			{
				return {
					...state,
					reOrderForm: {
						...state.reOrderForm,
						lines: action.data.lines,
					}
				}
			}
		case types.SET_REORDER_LINE_QTY:
			return {
				...state,
				reOrderForm: {
					...state.reOrderForm,
					lines: state.reOrderForm.lines.map((line, index) =>
						index === action.index
							? { ...line, rdr1_quantity: action.value }
							: line
					),
				},
			}
			case types.RESET_REORDER_FORM:
				{
					return {
						...state,
						reOrderForm: {
							...state.reOrderForm,
							...action.data,
						},
					};
				}
			case types.RESET_CONFIRMATION_MODAL:
				{
					return {
						...state,
						rejectionModal: false,
						selectedSO: [],
						updateSuccessModal: false,
						updatePending: false,
						confirmationSuccess: false,
						rejectionSuccess: false,
						responseMessage: '',
					};
				}
		default:
			return state;

};
}
export default reducers;



export const actions = {
	setState: (data) => ({ type: types.SET_STATE, data }),
	setReorderNotes: (data) => ({ type: types.SET_REORDER_NOTES, data }),
	setReorderLines: (data) => ({ type: types.SET_REORDER_LINES, data }),
	setReorderLineQTY: (index, value) => ({ type: types.SET_REORDER_LINE_QTY, index, value }),
	resetReOrderForm: (data) => ({ type: types.RESET_REORDER_FORM, data }),
	resetConfirmationModal: () => ({ type: types.RESET_CONFIRMATION_MODAL }),
	loadSalesOrders: () => async (dispatch, getState) => {
		console.log('[SalesOrders.redux] loadSalesOrders');

		const 
			state    = getState(),
			loading  = state.salesOrders.loading,
			cardCode = state.salesOrders.cardCode,
			cardType = state.salesOrders.cardType;

		
		//console.log('cardCode', cardCode);
		//console.log('cardType', cardType);

		if (loading) {
			return false;
		}

		dispatch(actions.setState({ loading: true, loaded: false }));

		try {
			let response = await api.get('/sales-orders', {
				params: {
					cardCode
				},
			});
			console.log('res', response)

			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
					loaded: true,
					salesOrders: response,
				},
			});
		} catch (err) {
			console.error(err);
			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
					loaded: true,
					salesOrders: [],
					cardName: '',
				},
			});
		}
	},

	//loadAttachments
	getAttachments: (atcEntry) => async (dispatch) => {
		try {

			const atcData = await api.get('/sales-orders/attachments', {
				params: {
					atcEntry: atcEntry,
				},
			});
			console.log('loadAttachments response', atcData)
			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
					picturesLoading: false,
					modalOpen: true,
					pictureAttachments: atcData.attachments,
					msgAttachments: atcData.msgAttachments, 	// base64
					msgObjects: atcData.msgObjects, 			// text information in objects
					attachmentErrors: atcData.errors
				},
			});
		} catch (err) {
			console.error(err);
			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
					loadedVendorCode: true,
					cardCode: '',
					cardType: '',
				},
			});
		}
	},

	//Gets data from sales order
	loadReorder: (docEntry) => async (dispatch) => {
		// just clear notes, lines will be overwritten. If I try to reset the lines too its causing issues. this works for now.
		dispatch(actions.resetReOrderForm({notes: ''}))
		try {

			const header = await api.get('/sales-orders/reorder/header', {
				params: {
					docEntry: docEntry,
				},
			});

			const lines = await api.get('/sales-orders/reorder/lines', {
				params: {
					docEntry: docEntry,
				},
			});

			let inventoryItems = lines.filter(line => line.oitm_invntItem !== 'N');

			//console.log('loadReorder response header', header[0])
			//console.log('loadReorder response lines', lines)

			// We need to organize the orderliness by color then sizes
			const prioritySuffixes = [
				"-XXS", "-XS", "-SM", "-MD", "-LG", "-XL", "-2XL", "-3XL", "-4XL", "-5XL", "-6XL",
				"-NB", "-6MO", "-12MO", "-18MO", "-24MO", "-LT", "-XLT", "-2XLT", "-3XLT", "-4XLT",
				"-S/M", "-L/XL", "-XL/2XL", "-YOUTH", "-OSFM", "-OSFMADULT", "-SMALL", "-MEDIUM",
				"-LARGE", "-2T", "-3T", "-4T", "-4FT", "-6FT", "-8FT", "-12FT", "-16FT", "-CUSTOM"
			];

			// extracts the size suffix if it exists
			const extractSizeSuffix = (itemCode) => {
				for (const suffix of prioritySuffixes) {
					if (itemCode.endsWith(suffix)) {
						return suffix;
					}
			}
				return null;
			};

			// keep the colors together, extracts the base code before size
			const extractBaseCode = (itemCode) => {
				const sizeSuffix = extractSizeSuffix(itemCode);
				return sizeSuffix ? itemCode.slice(0, -sizeSuffix.length) : itemCode;
			};

			const sortLines = (a, b) => {
				// compare by base code 
				const baseA = extractBaseCode(a.rdr1_itemCode);
				const baseB = extractBaseCode(b.rdr1_itemCode);
				if (baseA < baseB) return -1;
				if (baseA > baseB) return 1;

				// compare by size order
				const suffixA = extractSizeSuffix(a.rdr1_itemCode);
				const suffixB = extractSizeSuffix(b.rdr1_itemCode);
				const indexA = suffixA ? prioritySuffixes.indexOf(suffixA) : Infinity;
				const indexB = suffixB ? prioritySuffixes.indexOf(suffixB) : Infinity;

				return indexA - indexB;
			};

			const sortedLines = [...inventoryItems].sort(sortLines);


			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
					showReorderForm: true,
					header: header[0],
				},
			});
			dispatch({
				type: types.SET_REORDER_LINES,
				data: {
					lines: sortedLines,
				},
			});
		} catch (err) {
			console.error(err);
			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false
				},
			});
		}
	},

	submitReorder: () => async (dispatch, getState) => {

		dispatch(actions.setState({submitPending: true}))
		try {
			const userKey = Cookies.get('TS_UserKey', '');
			console.log('submitReorder userKey', userKey)
			const state     = getState(),
            	lines       = state.salesOrders.reOrderForm.lines,
				notes       = state.salesOrders.reOrderForm.notes,
            	header      = state.salesOrders.header,
				cardCode	= state.salesOrders.cardCode,
				cardType	= state.salesOrders.cardType,
				cardName	= state.salesOrders.header.ocrd_cardName,
				orginalSO	= state.salesOrders.header.ordr_project_name,
				projectName	= state.salesOrders.header.ordr_docNum;

			const result = await api.post('/sales-orders/reorder/send-reorder', {
					lines: lines,
					notes: notes,
					header: header,
					cardCode: cardCode,
					cardType: cardType,
					cardName: cardName,
					userKey: userKey,
					orginalSO: orginalSO,
					projectName: projectName
				},
			);

			//console.log('Result', result)

			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
					showReorderForm: false,
					submitPending: false,
				},
			});

		} catch (err) {
			console.error(err);
			dispatch({
				type: types.SET_STATE,
				data: {
					submitPending: false,
				},
			});
		}
	},

	approveSO: (record) => async (dispatch, getState) => {
		console.log('record', record)
		dispatch(actions.setState({updatePending: true}))
		try {
			const userKey = Cookies.get('TS_UserKey', '');
			console.log('submitReorder userKey', userKey)
		
			const state     = getState(),
				isDPCustomer       = state.salesOrders.isDPCustomer,
				cardCode       = state.salesOrders.cardCode;

			//set one up for DP and another for non DP
			const result = await api.post('/sales-orders/confirm', {
				isDPCustomer: isDPCustomer, //true //DEBUG between DP and non DP customers
				order: record,
				cardCode: cardCode
				},
			);

			console.log('Result', result)

			dispatch({
				type: types.SET_STATE,
				data: {
					updatePending: false,
					updateSuccessModal: true,
					confirmationSuccess: true,
					responseMessage: result.message,
				},
			});

		} catch (err) {
			console.error(err);
			message.error(err.response.data.message)
			dispatch({
				type: types.SET_STATE,
				data: {
					updatePending: false,
				},
			});
		}
	},

	submitRejection: (rejectionMessage, record) => async (dispatch, getState) => {

		dispatch(actions.setState({updatePending: true, }))
		if (rejectionMessage === ''){
			message.error('Please include a reason for rejection');
			dispatch(actions.setState({updatePending: false, }))
			return;
		}
		try {
			const state     = getState(),
				bpName      = state.salesOrders.bpName,
				cardCode	= state.salesOrders.cardCode;

			const result = await api.post('/sales-orders/reject', {
					rejectionMessage: rejectionMessage,
					order: record,
					bpName: bpName,
					cardCode: cardCode
				},
			);

			console.log('Result', result)

			dispatch({
				type: types.SET_STATE,
				data: {
					updatePending: false,
					updateSuccessModal: true,
					rejectionSuccess: true,
					rejectionModal: false,
					responseMessage: result.message,
				},
			});

		} catch (err) {
			console.error(err);
			message.error(err.response.data.message)
			dispatch({
				type: types.SET_STATE,
				data: {
					updatePending: false,
				},
			});
		}
	},

	loadVendorCode: () => async (dispatch) => {
		try {
			const userKey = Cookies.get('TS_UserKey', '');
			const response = await api.get('/invoices/vendor-code', {
				params: {
					userKey: userKey,
				},
			});
			console.log('loadVendorCode userKey', userKey)
			console.log('loadVendorCode response', response)

			let isDPPaymentTerm;
			//DEBUG test dp customer:
			//response.BPPaymentTerms = '30% Down/Due before shipment'
			//we are also doing this on the columns, is this still needed? 
			if(response.BPPaymentTerms){
				isDPPaymentTerm = response.BPPaymentTerms.toLowerCase().includes('% down');
			}
			console.log('response', response)
			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
					loadedVendorCode: true,
					cardCode: response.BPCode,
					cardType: response.BPType,
					isDPCustomer: isDPPaymentTerm,
					customerProfileId_from_SAP: response.CustomerProfileId,
					bpName: response.BPName
				},
			});
		} catch (err) {
			console.error(err);
			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
					loadedVendorCode: true,
					cardCode: '',
					cardType: '',
				},
			});
		}
	},

	load_pdf_document: (docEntry) => async() => {
		const response = await api.get('/sales-orders/order-document', {
			params: {
				docEntry: docEntry,
			},
		});

		let fileData = response.document.FileData;
		fileData = base64toPDF(fileData);

		const fileURL = URL.createObjectURL(fileData);

		if (fileData) {
			window.open(fileURL);
		} else {
			message.error(`Could not load report for document ${docEntry}`);
		}
	},

	resetSOPDFDialog: () => ({
		type: types.SET_STATE, data: {
			showSOPDFDialog: false,
		},
	}),

	loadInvoicePreview: (docEntry) => async (dispatch) => {
		console.log('invoice pdf', docEntry)

		const objType = '13'; //portal_ar_invoice
		try {
			dispatch(actions.setState({ pdfModalLoading: true }));

			const response = await api.get('/invoices/preview', {
				params: {
					docEntry,
					objType
				}
			});

			let fileData = response.FileData;
			let pdf = base64toPDF(fileData);

			
			dispatch(actions.setState({ pdfModalKey: docEntry }));
			dispatch(actions.setState({ pdfModalData: fileData }));
			dispatch(actions.setState({ pdfFilePreview: pdf }));
			dispatch(actions.setState({ pdfModalLoading: false }));
			
			//const fileURL = URL.createObjectURL(fileData);
			// if (fileData) {
			// 	window.open(fileURL);
			// } else {
			// 	message.error(`Could not load report for document ${docEntry}`);
			// }
		} catch (e) {
			console.error(e);
			message.error('Could not load invoice preview');
			dispatch(actions.setState({ pdfModalLoading: false }));
		}
	},

	loadSalesOrderPreview: (docEntry, objType) => async (dispatch) => { 
		
		console.log('[invoices.redux] loadSalesOrderPreview  docEntry: ' + docEntry);
		try {
			dispatch(actions.setState({ pdfModalLoading: true }));
			const response = await api.get('sales-orders/preview', {
				params: {
					docEntry,
					objType: '17'
				}
			});

			console.log(response)
			let fileData = response.FileData;
			let pdf = base64toPDF(fileData);

			dispatch(actions.setState({ pdfModalKey: docEntry }));
			dispatch(actions.setState({ pdfModalData: fileData }));
			dispatch(actions.setState({ pdfFilePreview: pdf }));
			dispatch(actions.setState({ pdfModalLoading: false }));
		} catch (e) {
			console.error(e);
			message.error('Could not load sales order preview');
			dispatch(actions.setState({ pdfModalLoading: false }));
		}
	},

};
